import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <ReflectionProbe>: puts a reflection probe into the scene at the node's transform, which the
 * scene's probes capture and draw (`r3f/reflectionProbe/sceneProbes.ts`). It draws nothing of its own,
 * but Godot's editor gizmo while it is selected (`reflection_probe_gizmo_plugin.cpp:152`).
 */
import { useMemo } from 'react';
import { extend } from '@react-three/fiber';
import { centredAabb } from '../../../godot/math/aabb';
import { NodeAabb } from '../../../r3f/components/NodeAabb';
import { useTreeOrder } from '../../../r3f/contexts/TreeOrderContext';
import { PluginGizmo } from '../../../r3f/gizmo/PluginGizmo';
import { ReflectionProbeObject } from '../../../r3f/reflectionProbe/reflectionProbeObject';
import { useSceneProbes } from '../../../r3f/reflectionProbe/useSceneProbes';
import { Node3D } from '../../base/node3d/Component';
import { ReflectionProbeGizmo } from './Gizmo';
/** An element, not a `<primitive>`: it carries no material, and R3F sets its fields as props. */
const ReflectionProbeElement = extend(ReflectionProbeObject);
export function ReflectionProbe({ node, children }) {
    useSceneProbes();
    const treeOrder = useTreeOrder();
    const probe = node.properties;
    const aabb = useMemo(() => centredAabb(probe.size), [probe.size]);
    return (_jsxs(Node3D, { node: node, children: [_jsx(ReflectionProbeElement, { probe: probe, treeOrder: treeOrder }), _jsx(NodeAabb, { aabb: aabb }), _jsx(PluginGizmo, { drawnFor: "selected-only", children: _jsx(ReflectionProbeGizmo, { probe: probe }) }), children] }));
}
//# sourceMappingURL=Component.js.map